import { createAction } from '@reduxjs/toolkit';

import type { ModalTypes } from './instances';

export const openModal = createAction<{ modalType: ModalTypes; params?: any }>('modals/openModal');
export const closeModal = createAction('modals/closeModal'); 